import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { designTokens } from './tokens';

export function PageLayout({ children, overview = false }: { children: ReactNode; overview?: boolean }) {
  return <Box data-testid="page-canvas" sx={{ minWidth: 0, minHeight: 0, height: '100%', bgcolor: designTokens.color.pageCanvas, overflow: 'auto' }}>
    <Box
      data-testid="page-content"
      sx={overview ? { minHeight: '100%' } : {
        width: '100%',
        height: '100%',
        minHeight: '100%',
      }}
    >
      {children}
    </Box>
  </Box>;
}
